import React from 'react';
import { useOfferTimer } from '../hooks/useOfferTimer';
export function AnnouncementBar() {
  const {
    isExpired,
    isInitialized,
    hours,
    minutes,
    seconds
  } = useOfferTimer();
  if (!isInitialized) return null;
  if (isExpired) {
    return <section className="w-full sticky top-0 z-50 flex items-center justify-center" style={{
      background: '#1a0000',
      borderBottom: '1px solid rgba(204, 0, 0, 0.4)',
      padding: '10px 20px'
    }} data-id="element-1">
        <p className="text-[#cc0000] text-sm font-semibold font-['Inter',sans-serif] text-center" data-id="element-2">
          Esta oferta ha expirado.
        </p>
      </section>;
  }
  return <section className="w-full sticky top-0 z-50 flex items-center justify-center gap-3" style={{
    background: '#1a0000',
    borderBottom: '1px solid rgba(204, 0, 0, 0.4)',
    padding: '10px 20px'
  }} data-id="element-3">
      {/* 1. Red pill badge */}
      <span className="whitespace-nowrap" style={{
      background: '#cc0000',
      color: '#ffffff',
      fontSize: '11px',
      fontWeight: 700,
      padding: '3px 10px',
      borderRadius: '50px'
    }} data-id="element-4">
        🔥 50% OFF
      </span>

      {/* 2. Label — hidden on mobile */}
      <span className="hidden sm:inline whitespace-nowrap font-['Inter',sans-serif]" style={{
      color: '#888888',
      fontSize: '12px'
    }} data-id="element-5">
        La oferta expira en:
      </span>

      {/* 3. Timer digits inline */}
      <span className="whitespace-nowrap" data-id="element-6">
        <span id="vzla-hours" className="text-[#cc0000] text-[18px] max-sm:text-[16px]" style={{
        fontFamily: "'Courier New', monospace",
        fontWeight: 700
      }} data-id="element-7">
          {hours}
        </span>
        <span style={{
        color: 'rgba(255,255,255,0.4)',
        fontFamily: "'Courier New', monospace",
        fontWeight: 700,
        fontSize: '18px'
      }} data-id="element-8">
          :
        </span>
        <span id="vzla-minutes" className="text-[#cc0000] text-[18px] max-sm:text-[16px]" style={{
        fontFamily: "'Courier New', monospace",
        fontWeight: 700
      }} data-id="element-9">
          {minutes}
        </span>
        <span style={{
        color: 'rgba(255,255,255,0.4)',
        fontFamily: "'Courier New', monospace",
        fontWeight: 700,
        fontSize: '18px'
      }} data-id="element-10">
          :
        </span>
        <span id="vzla-seconds" className="text-[#cc0000] text-[18px] max-sm:text-[16px]" style={{
        fontFamily: "'Courier New', monospace",
        fontWeight: 700
      }} data-id="element-11">
          {seconds}
        </span>
      </span>

      {/* 4. Vertical divider */}
      <div style={{
      width: '1px',
      height: '16px',
      background: 'rgba(255,255,255,0.15)',
      margin: '0 4px'
    }} data-id="element-12" />

      {/* 5. Original price strikethrough */}
      <span className="whitespace-nowrap font-['Inter',sans-serif]" style={{
      color: '#666666',
      fontSize: '15px',
      fontWeight: 400,
      textDecoration: 'line-through'
    }} data-id="element-13">
        $19,99
      </span>

      {/* 6. Current price */}
      <span className="whitespace-nowrap font-['Inter',sans-serif] text-[20px] max-sm:text-[17px]" style={{
      color: '#ffffff',
      fontWeight: 800,
      marginLeft: '6px'
    }} data-id="element-14">
        $9,99
      </span>
    </section>;
}